import React from 'react';
import SEOHead from '@/components/seo/SEOHead';
import { Footer } from '@/components/layout/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEOHead
        title="Contact Meduler"
        description="Contact Meduler with questions about the medication management app, privacy, accessibility, or support."
        canonicalUrl="https://www.meduler.com/contact"
      />
      <main className="flex-1">
        <section className="max-w-3xl mx-auto px-4 py-16 md:py-24">
          <p className="text-sm font-semibold uppercase tracking-wide text-purple-600 mb-3">Support</p>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Contact Meduler</h1>
          <p className="text-xl text-gray-600 leading-relaxed mb-10">
            Questions about Meduler, privacy, accessibility, or the Plus waitlist? We are happy to
            help with the public product and website.
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Product support</h2>
              <p>
                Email <a className="text-purple-700 underline" href="mailto:support@meduler.com">support@meduler.com</a>
                {' '}with questions about using Meduler, installing the Progressive Web App, accessibility,
                or the Plus waitlist. Please include the page or feature you are asking about, but do
                not include medication names, diagnoses, prescriptions, or other sensitive health
                information in a general support email.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Privacy questions</h2>
              <p>
                Read the <a className="text-purple-700 underline" href="/privacy">Privacy Policy</a> for
                information about data handling and user choices. If your question is specifically
                about privacy, identify it as a privacy request in your message and share only the
                minimum information needed for the team to respond.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">What support cannot do</h2>
              <p>
                Meduler support cannot diagnose a condition, change a prescription, tell you whether
                to take a dose, or provide emergency care. Ask a qualified doctor or pharmacist about
                treatment decisions. For an urgent medical situation, contact your local emergency
                service immediately. Meduler is a personal organization tool, not a medical device or
                a substitute for professional care.
              </p>
            </section>

            <p>
              You may also find quick answers in the <a className="text-purple-700 underline" href="/faq">FAQ</a>,
              <a className="text-purple-700 underline ml-1" href="/features">feature guide</a>, and
              <a className="text-purple-700 underline ml-1" href="/how-it-works">setup guide</a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}